import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type AbilitiesService from 'ember-can/services/abilities';

export default class LocationOverviewEmployeesGroupsRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service declare router: RouterService;

  titleToken = 'Groups';

  beforeModel(): void {
    if (this.abilities.cannot('visit global employee-group')) {
      void this.router.transitionTo('location-overview.employees.directory');
    }
  }
}
